export default __webpack_public_path__ + "static/lf-rubrik-8b8ab77659b331e13eb909a3be926ad0.woff2";